// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"fgdBP1g","size-sm":"wP3RWd_","sizeSm":"wP3RWd_","mobile":"Gj9vWTd"};